import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { ChevronRight, ArrowLeft } from 'lucide-react';
import { CONTACT_EMAIL } from '../data/content';

export default function LegalPageLayout({ title, updated, intro, sections }) {
  return (
    <>
      <Header />
      <section className="bg-mist border-b border-line">
        <div className="max-w-4xl mx-auto px-5 md:px-8 py-16">
          <div className="flex items-center gap-2 text-sm text-slate-500 mb-6">
            <Link to="/" className="hover:text-royal">Home</Link>
            <ChevronRight className="w-4 h-4" />
            <span className="text-navy font-medium">{title}</span>
          </div>
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-navy tracking-tight">{title}</h1>
          {updated && <div className="mt-3 font-mono text-xs text-slate-500">Last updated: {updated}</div>}
          {intro && <p className="mt-5 text-lg text-slate-600 leading-relaxed">{intro}</p>}
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-4xl mx-auto px-5 md:px-8">
          <article className="space-y-10">
            {sections.map((s, i) => (
              <div key={i} id={`s-${i + 1}`}>
                <h2 className="font-display text-2xl md:text-3xl font-extrabold text-navy tracking-tight mb-3">
                  <span className="font-mono text-royal text-base mr-3">0{i + 1}</span>{s.title}
                </h2>
                {s.paragraphs && s.paragraphs.map((p, j) => <p key={j} className="text-slate-700 leading-relaxed mb-3 text-[15px]">{p}</p>)}
                {s.bullets && (
                  <ul className="mt-3 space-y-2">
                    {s.bullets.map((b, k) => (
                      <li key={k} className="flex items-start gap-2 text-slate-700 text-[15px]">
                        <span className="mt-2 w-1.5 h-1.5 rounded-full bg-royal flex-shrink-0" />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </article>

          <div className="mt-14 pt-8 border-t border-line flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <Link to="/" className="inline-flex items-center gap-1.5 text-slate-600 hover:text-royal font-medium"><ArrowLeft className="w-4 h-4" /> Back to home</Link>
            <div className="text-sm text-slate-500">Questions? <a href={`mailto:${CONTACT_EMAIL}`} className="text-royal font-semibold hover:underline">{CONTACT_EMAIL}</a></div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
